define([
	"csi/config",
	"csi/reflection",
	"dojo/_base/declare",
	"underscore",
	"SiteAdmin/AttributeMap/AttributeMapTable"
], function(config, reflection, declare, _, AttributeMapTable) {

	var MAP_SETTING_ID = "SectionItemAttributeMap";
	var MAP_ENTRY_NODE_TYPE = "_SpecificationSectionItemAttributeMapEntry_";
	var DEST_ATTR_ID_ATTR = "SpecificationSectionItemAttributeId";

	var SOURCE_CLASS_NAME = "SpecificationItemDefinition";
	var SOURCE_OPTIONAL_CONFIG = "ItemDefinitionOptionalAttributes";

	var DEST_CLASS_NAME = "SpecificationSectionItem";
	var DEST_OPTIONAL_CONFIG = "SectionItemOptionalAttributes";

	var SOURCE_ATTR_NAMES = [
		"Node Name",
		"Description"
	];

	var DEST_CLASS_NAMES = [DEST_CLASS_NAME];
	var DEST_ATTR_NAMES = [
		"Node Name",
		"Description"
	];

	AttributeMapTable.watchValueDropDown(MAP_ENTRY_NODE_TYPE, DEST_ATTR_ID_ATTR);

	var _SpecificationSectionItemMapTable = declare(AttributeMapTable, {
		settingsUrl: null,
		setupSettingsUrl: null,
		mapSettingId: MAP_SETTING_ID,
		mapEntryNodeType: MAP_ENTRY_NODE_TYPE,
		destAttrIdAttr: DEST_ATTR_ID_ATTR,
		sourceClassName: SOURCE_CLASS_NAME,
		sourceAttributeNames: SOURCE_ATTR_NAMES,

		_getRootRequest: function(/*Node*/node) {
			this.settingsUrl = node.Settings;
			this.setupSettingsUrl = node.SetupSettings;
			return this.inherited(arguments);
		},

		_getCustomAttributesInner: function(className) {
			// summary: return an array of custom attributes (and relations), unsorted
			var rc = reflection.getClass(className);
			var optionalConfig = this._getSettings()[SOURCE_OPTIONAL_CONFIG];
			return rc ? _.filter(rc.getAttributes(true), function(attr) {
				if (!attr.isCustom)
					return false;
				if (!attr.isOptional)
					return true;

				return optionalConfig[attr.getId()];
			}) : [];
		}
	});

	_SpecificationSectionItemMapTable.SOURCE_CLASS_NAME = SOURCE_CLASS_NAME;
	_SpecificationSectionItemMapTable.SOURCE_ATTR_NAMES = SOURCE_ATTR_NAMES;
	_SpecificationSectionItemMapTable.DEST_CLASS_NAMES = DEST_CLASS_NAMES;
	_SpecificationSectionItemMapTable.DEST_ATTR_NAMES = DEST_ATTR_NAMES;
	_SpecificationSectionItemMapTable.DEST_OPTIONAL_CONFIG = DEST_OPTIONAL_CONFIG;

	return _SpecificationSectionItemMapTable;
});